export enum JobOptions {
	None = 0,
	LinksDisabled = 1,
	Hidden = 2
}
